import { render, staticRenderFns } from "./AddOrEditBusinessManagerModal.vue?vue&type=template&id=3328dfe6&"
import script from "./AddOrEditBusinessManagerModal.vue?vue&type=script&lang=js&"
export * from "./AddOrEditBusinessManagerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports